import { T } from 'consts/translationKeys'
import { translate } from 'utils/translations'
import ActionButton from '../ActionButton'
import SnowflakeIcon from 'assets/svgr-icons/Snowflake.svg'
import { useFrameExtraction } from './useFrameExtraction'
import { MOBILE_SIZE_BREAKPOINT } from 'consts'
import { useResponsive } from 'hooks/useResponsive'

export const FrameExtractButton = () => {
  const { handleExtractFrame, isButtonDisabled } = useFrameExtraction()
  const isMobile = useResponsive(MOBILE_SIZE_BREAKPOINT)

  return (
    <ActionButton
      icon={<SnowflakeIcon />}
      tooltipText={translate(T.FREEZE_FRAME_LABEL)}
      onClick={handleExtractFrame}
      disabled={isButtonDisabled}
      title={isMobile ? translate(T.FREEZE_FRAME_LABEL) : undefined}
    />
  )
}
